import React from "react";
import styles from "../components/laymanComp_css/LaymanPage18.module.css";
import Common_html from "./Common_html";
import BlockData from "../../../layman-explanation-json/yhvh.json";

export default function LaymanPage18_yhvh() {
  return (
    <>
   <Common_html BlockData={BlockData} />
    </>
  );
}